import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../store/root-reducer';
import {
  resetSubscription,
  resetPurchaseDialerModifySubscriptionResponse,
  resetCalculateCreditsPricesRequest,
  resetPurchaseCreditsRequest,
} from '../../billing-subscription-slice';
import { selectPaddleCustomerId } from '../../../../../home/home-slice';
import {
  paddlePollingThunk,
  purchaseDialerModifySubscriptionRequest,
  calculateCreditsPricesRequest,
  purchaseCreditsRequest,
} from '../../extra-actions';
import { PaddleApplicationType, PaddleUpgradeSubscriptionRequest } from '../../types/paddle';
import {
  CalculateCreditsPricesRequest,
  PurchaseCreditsRequest,
} from '../../types/purchase-credits';
import DialerPlans from './dialer-plans';

const mapStateToProps = (state: RootState) => ({
  getCouponCodeResponse: state.billingAndSubscription.applyCouponCodeResponse,
  sendGetDialerSubscriptionRequestStatus:
    state.billingAndSubscription.getDialerSubscriptionRequest.status,
  sendGetDialerSubscriptionResponse:
    state.billingAndSubscription.getDialerSubscriptionResponse,
  sendGetDialerPlansResponse:
    state.billingAndSubscription.getDialerPlansResponse,
  sendGetPurchaseDialerModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseDialerModifySubscriptionRequest.status,
  sendPurchaseDialerModifySubscriptionResponse:
    state.billingAndSubscription.purchaseDialerModifySubscriptionResponse,

  couponCodeDiscount:
    state.billingAndSubscription.applyCouponCodeResponse?.discountValue,
  couponCodeDiscountType:
    state.billingAndSubscription.applyCouponCodeResponse?.discountType,
  userId: state.home?.userId,
  shAccountId: state.home?.shAccountId,
  userEmail: state.home?.email,
  paddleCustomerId: selectPaddleCustomerId(state),

  // Credit pricing
  calculateCreditsPricesRequestStatus:
    state.billingAndSubscription.calculateCreditsPricesRequest.status,
  calculateCreditsPricesResponse:
    state.billingAndSubscription.calculateCreditsPricesResponse,
  purchaseCreditsRequestStatus:
    state.billingAndSubscription.purchaseCreditsRequest.status,
  purchaseCreditsResponse:
    state.billingAndSubscription.purchaseCreditsResponse,
  paddlePolling: state.billingAndSubscription.paddlePolling,

});

const mapDispatchToProps = {
  sendPurchaseDialerModifySubscriptionRequest: (
    payload: PaddleUpgradeSubscriptionRequest,
  ) => purchaseDialerModifySubscriptionRequest(payload),
  resetSubscription: () => resetSubscription(),
  resetPurchaseDialerModifySubscriptionResponse: () =>
    resetPurchaseDialerModifySubscriptionResponse(),
  startPaddlePollingThunk: (payload: {
    shAccountId: number;
    applicationType: PaddleApplicationType;
    planId?: number;
  }) => paddlePollingThunk(payload),

  // Credit pricing
  sendCalculateCreditsPricesRequest: (
    payload: CalculateCreditsPricesRequest,
  ) => calculateCreditsPricesRequest(payload),
  sendPurchaseCreditsRequest: (payload: PurchaseCreditsRequest) =>
    purchaseCreditsRequest(payload),
  resetCalculateCreditsPricesRequest: () =>
    resetCalculateCreditsPricesRequest(),
  resetPurchaseCreditsRequest: () => resetPurchaseCreditsRequest(),

};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export default connector(DialerPlans);
